import apis from "../../../api/api.actions";
import {
  refreshAdminToken,
  refreshTempToken,
  refreshToken,
} from "../../../config";
// import { refreshActive } from "../../../App";
export const authLogin = (data) =>
  apis.auth("admin/login", data).then((res) => res);

export const userRegConfirm = (data) =>
  apis.createData("phoneno-verification-status", data).then((res) => res);

export const userLogin = (data) =>
  apis.createData("user/login", data).then((res) => res);

export const companyLogin = (data) =>
  apis.createData("company/login", data).then((res) => res);

export const userReg = (data) =>
  apis.createData("phoneno-verification", data).then((res) => res);
export const verifyOtp = (data) =>
  apis.createData("verify-otp", data).then((res) => res);

export const refreshApi = (data) =>
  apis.createData("refresh", data).then((res) => res);

export const forgotPassword = (data) =>
  apis.createData("forgot-password", data).then((res) => res);

export const switchAccount = (data, token) =>
  apis.createData("v1/common/switch-account", data, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  }).then((res) => res);

export const getUserAccounts = (token) =>
  apis.getDatas("v1/common/user-accounts", {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  }).then((res) => res);

export const selectApplicationContext = (data, token) =>
  apis.createData("v1/user/select-application-context", data, {
    headers: { Authorization: `Bearer ${token}` },
  }).then((res) => res);
